import React from "react";
import ajax from "./../../lib/ajax.js";
import context from "../../lib/context.js";
import util from "./../../lib/util.js";
import { FormControl, ControlLabel, Button, Checkbox, Alert, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import Company from "./../shared/company.jsx";
import Office from "./../shared/office.jsx";
import DatePicker from "react-bootstrap-date-picker";
import SalarySurvey from "./salary-survey.jsx";
import { browserHistory } from "react-router";
import moment from "moment";
import RequestActivityList from "./request-activity-list.jsx";
import Navigation from "../shared/navigation.jsx";
import CodeList from "./../shared/codelist.jsx";
import IndustryCategory from "./../shared/industry-category";
import StringAutoComplete from "./../shared/string-autocomplete";
import State from "./../shared/state.jsx";

export default class RequestEntry extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            request: null,
            errors: [],
            successMessage: '',
            isCopy: false,
            readOnly: true,
            showReturnToManager: false,
            showCloseRequest: false,
            showSuccessfulPlacement: false,
            showNotes: false,
            showNotesType: '',
            scrollTop: false,
            resources: {}
        }

        this.role = context.getRouteParam(this, "role");
        this.onCompanyChange = this.onCompanyChange.bind(this);
        this.onCostCenterChange = this.onCostCenterChange.bind(this);
        this.onNumberChange = this.onNumberChange.bind(this);
        this.onTargetHireDateChange = this.onTargetHireDateChange.bind(this);
        this.onRequestChange = this.onRequestChange.bind(this);
        this.onFormControlChange = this.onFormControlChange.bind(this);
        this.onSalaryChange = this.onSalaryChange.bind(this);
        this.onCheckBoxChange = this.onCheckBoxChange.bind(this);
        this.onPositionTypeClick = this.onPositionTypeClick.bind(this);
        this.onDivisionClick = this.onDivisionClick.bind(this);
        this.onCurrentJobTypeClick = this.onCurrentJobTypeClick.bind(this);
        this.onExternalSalaryComparison = this.onExternalSalaryComparison.bind(this);
        this.onExternalSalaryComparisonRemove = this.onExternalSalaryComparisonRemove.bind(this);
        this.onAddSalarySurveyClick = this.onAddSalarySurveyClick.bind(this);
        this.onYesNoClick = this.onYesNoClick.bind(this);
        this.loadViewModel = this.loadViewModel.bind(this);
        this.validate = this.validate.bind(this);
        this.validateSurvey = this.validateSurvey.bind(this);
        this.getButtons = this.getButtons.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.save = this.save.bind(this);
        this.saveStatus = this.saveStatus.bind(this);
        this.saveNotes = this.saveNotes.bind(this);
        this.getFormattedDate = this.getFormattedDate.bind(this);
        this.onApplicantLogClick = this.onApplicantLogClick.bind(this);
        this.isReadOnly = this.isReadOnly.bind(this);
        this.getLinks = this.getLinks.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
        this.onTimeChange = this.onTimeChange.bind(this);
        this.onZipCodeChange = this.onZipCodeChange.bind(this);
        this.showPrfSubmitted = this.showPrfSubmitted.bind(this);
        this.showRequestedBy = this.showRequestedBy.bind(this);
        this.onReportCountryChange = this.onReportCountryChange.bind(this);
        this.reasonForReturn = null;
        this.editNotes = null;
        this.loadResources = this.loadResources.bind(this);
    }

    componentDidMount() {
        this.loadViewModel();
        this.loadResources();
    }

    loadViewModel() {
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait...",
            buttons: "close"
        });

        const self = this;

        var action = 'get-request';

        if (this.props.route.path == 'supervisor/request-copy/:requestId') {
            action = 'copy-request';
            
            this.setState({ isCopy: true })
        }

        ajax.vm()
            .get(`${action}/${this.props.routeParams.requestId}/${this.role}`)
            .then(function (res) {
                context.message({ show: false });

                res.data.salarySurveys.map(function(survey, i) { survey.errors = []; });

                self.setState({
                    readOnly: self.isReadOnly(res.data, true),
                    request: res.data 
                });

                if (self.props.route.path == 'exec/request-approve/:requestId') {
                    if (self.role == 'exec') {
                        self.saveStatus("APPROVED_EXEC", self.state.resources.requestApprovedSuccessfully, "");
                    }
                    else {
                        window.location = context.routeUrl(`home?msg=${encodeURI("Access denied")}`);
                    }
                }
                else if (self.props.route.path == 'hr/request-approve/:requestId') {
                    if (self.role == 'hr' &&  res.data.isHRManager) {
                        self.saveStatus("APPROVED_HR", self.state.resources.requestApprovedSuccessfully, "");
                    }
                    else {
                        window.location = context.routeUrl(`home?msg=${encodeURI(self.state.resources.accessDenied)}`);
                    }
                }
                else if (self.props.route.path == 'exec/request-reject/:requestId') {
                    if (self.role == 'exec') {
                        self.saveStatus("REJECTED", self.state.resources.requestRejectedSuccessfully, "");
                    }
                    else {
                        window.location = context.routeUrl(`home?msg=${encodeURI(self.state.resources.accessDenied)}`);
                    }
                }
                else if (self.props.route.path == 'hr/request-reject/:requestId') {
                    if (self.role == 'hr' &&  res.data.isHRManager) {
                        self.saveStatus("REJECTED", self.state.resources.requestRejectedSuccessfully, "");
                    }
                    else {
                        window.location = context.routeUrl(`home?msg=${encodeURI(self.state.resources.accessDenied)}`);
                    }
                }
            })
            .catch(function (err) {
                let data = err.response.data;
                if (data.exceptionMessage && data.exceptionMessage.toLowerCase().indexOf("unauthorize") > -1) {
                    browserHistory.push(context.routeUrl(`home`));
                }
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
    }

    loadResources() {
        const self = this;

        ajax.vm()
            .get(`request-entry-resources`)
            .then(function (res) {
                self.setState({ resources: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                if (data.exceptionMessage && data.exceptionMessage.toLowerCase().indexOf("unauthorize") > -1) {
                    browserHistory.push(context.routeUrl(`home`));
                }
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
    }

    onRequestChange(values) {
        var request = this.state.request;

        for (var i = 0; i < values.length; i++) {
            var key = values[i].key;
            var value = values[i].value;
            request[key] = value;
        }

        this.setState({
            request: request,
            successMessage: ''
        });
    }

    onCompanyChange(value, description) {
        var values = [];
        values.push({ key: 'company', value: value });
        this.onRequestChange(values);
    }

    onCostCenterChange(value, description) {
        var values = [];
        values.push({ key: 'office', value: value });
        values.push({ key: 'officeName', value: description }); 
        this.onRequestChange(values);
    }

    onNumberChange(event) {
        if (util.isInteger(event.target.value, true)) {
            this.onFormControlChange(event);
        }
        else {
            this.onRequestChange([{ key: event.target.id, value: (this.state.request[event.target.id] == null ? '' : this.state.request[event.target.id] ) }]);
        }
    }

    onTargetHireDateChange(value, formattedValue) {
        var values = [];
        values.push({ key: 'targetHireDate', value: value });
        this.onRequestChange(values);
    }

    onFormControlChange(event) {
        var values = [];
        values.push({ key: event.target.id, value: event.target.value });
        this.onRequestChange(values);
    }

    onValueChange(value, description, key, param1, param2) {
        var values = [];
        values.push({ key: key, value: value });
        if (key == 'reportToCountry' && param2 !== undefined) {
            if (param2 == true) {
                values.push({ key: 'reportToState', value: '' });
            }
        }
        else if (key == 'remoteCountry' && param2 !== undefined) {
            if (param2 == true) {
                values.push({ key: 'remoteState', value: '' });
            }
        }

        this.onRequestChange(values);
    }

    onSalaryChange(event) {
        if (util.isDecimal(event.target.value, 7, 2, true)) {
            this.onFormControlChange(event);
        }
        else {
            this.onRequestChange([{ key: event.target.id, value: (this.state.request[event.target.id] == null ? '' : this.state.request[event.target.id] ) }]);
        }
    }

    onTimeChange(event) {
        if (util.isTime(event.target.value.trim(), true)) {
            this.onFormControlChange(event);
        }
        else {
            this.onRequestChange([{ key: event.target.id, value: (this.state.request[event.target.id] == null ? '' : this.state.request[event.target.id] ) }]);
        }
    }

    onCheckBoxChange(event) {
        var values = [];
        values.push({ key: event.target.id, value: event.target.checked });
        this.onRequestChange(values);
    }

    onPositionTypeClick(event) {
        var values = [];
        var value = 'Staffing';
        if (event.target.id == 'positionTypeNonStaffing') {
            value = 'Non-Staffing';
        }

        values.push({ key: 'positionType', value: value });
        this.onRequestChange(values);
    }

    onDivisionClick(event) {
        var values = [];
        values.push({ key: 'division', value: event.target.id.replace('division', '') });
        this.onRequestChange(values);
    }

    onCurrentJobTypeClick(event) {
        var values = [];
        values.push({ key: 'internalCandidateJobType', value: event.target.id.replace('internalCandidateJobType', '') });
        this.onRequestChange(values);
    }

    onExternalSalaryComparison(data) {
        var request = this.state.request;
        var survey = request.salarySurveys.filter(x => x.rowGuid == data.rowGuid);

        if (survey.length > 0) {
            request.salarySurveys[request.salarySurveys.indexOf(survey[0])] = data;
        }
        
        this.setState({ request: request });
    }

    onExternalSalaryComparisonRemove(data) {
        var request = this.state.request;
        var surveys = request.salarySurveys.filter(x => x.rowGuid != data.rowGuid);
        
        request.salarySurveys = [];

        if (data.salarySurveyID > 0) {
            request.salarySurveysDeleted.push(data);
        }

        this.setState({ request: request });

        const self = this;
        setTimeout(function() {
            var request = self.state.request;
            request.salarySurveys = surveys;

            self.setState({ request: request });
        }, 5)
    }

    onAddSalarySurveyClick(event) {
        var request = this.state.request;

        request.salarySurveys.push({
            salarySurveyID: 0,
            requestID: 0,
            sourceName: '',
            surveyDate: '',
            minSalary: '',
            maxSalary: '',
            notes: '',
            creationDate: '',
            creationOperator: '',
            modifyDate: '',
            modifyOperator: '',
            rowGuid: util.newGuid(),
            updated: true,
            errors: []
        });

        this.setState({
            request: request
        });
    }

    onYesNoClick(event) {
        var values = [];
        var value = true;
        if (event.target.id == event.target.name + 'No') {
            value = false;
        }

        values.push({ key: event.target.name, value: value });
        this.onRequestChange(values);
    }

    onZipCodeChange(item, value) {
        var values = [];

        if (item != null) {
            values.push({ key: "reportToCity", value: item.cityName });
            values.push({ key: "reportToZipCode", value: item.postalCode });
            values.push({ key: "reportToCountry", value: item.countryName });
            values.push({ key: "reportToState", value: item.provinceAbbr });
        }
        else {
            values.push({ key: "reportToZipCode", value: value });
        }
        
        this.onRequestChange(values);
    }

    onReportCountryChange() {
        $('#reportToState').val(this.state.request.reportToState);
    }

    getYesNoButtonClass(field, isYes) {
        if (this.state.request[field] == null)
            return '';

        return this.state.request[field] == isYes ? "btn-selected" : "";
    }

    getYesNoButtonValue(field) {
        if (this.state.request[field] == null)
            return '';

        return this.state.request[field] == true ? "Yes" : "No";
    }

    getErrorClass(field) {
        return this.state.errors.filter(x => x.field == field).length > 0 ? 'ap-report-control-error' : ''
    }

    validate() {
        var request = this.state.request;
        let msg = [];

        if (util.isStringNullOrEmpty(request.company)) {
            msg.push({field: 'company', error: this.state.resources.companyIsRequired});
        }

        if (util.isStringNullOrEmpty(request.office)) {
            msg.push({field: 'office', error: this.state.resources.costCenterIsRequired});
        }

        if (util.isStringNullOrEmpty(request.deptHeadCount)) {
            msg.push({field: 'deptHeadCount', error: this.state.resources.deptHeadcountIsRequired});
        }

        if (util.isStringNullOrEmpty(request.reportToAddress)) {
            msg.push({field: 'reportToAddress', error: this.state.resources.streetAddressIsRequired});
        }

        if (util.isStringNullOrEmpty(request.reportToCity)) {
            msg.push({field: 'reportToCity', error: this.state.resources.cityIsRequired});
        }

        if (util.isStringNullOrEmpty(request.reportToState)) {
            msg.push({field: 'reportToState', error: this.state.resources.stateIsRequired});
        }

        if (util.isStringNullOrEmpty(request.reportToZipCode)) {
            msg.push({field: 'reportToZipCode', error: this.state.resources.zipCodeIsRequired});
        }

        if (util.isStringNullOrEmpty(request.reportToCountry)) {
            msg.push({field: 'reportToCountry', error: this.state.resources.countryIsRequired});
        }

        if (util.isStringNullOrEmpty(request.remoteCity)) {
            msg.push({field: 'remoteCity', error: this.state.resources.virtualCityIsRequired});
        }

        if (util.isStringNullOrEmpty(request.remoteState)) {
            msg.push({field: 'remoteState', error: this.state.resources.virtualStateIsRequired});
        }

        if (util.isStringNullOrEmpty(request.remoteCountry)) {
            msg.push({field: 'remoteCountry', error: this.state.resources.virtualCountryIsRequired});
        }

        if (util.isStringNullOrEmpty(request.division)) {
            msg.push({field: 'division', error: this.state.resources.divisionCompanyIsRequired});
        }

        if (util.isStringNullOrEmpty(request.reportToFullName)) {
            msg.push({field: 'reportToFullName', error: this.state.resources.reportsToIsRequired});
        }

        if (util.isStringNullOrEmpty(request.positionTitle)) {
            msg.push({field: 'positionTitle', error: this.state.resources.positionTitleIsRequired});
        }

        if (util.isStringNullOrEmpty(request.industry)) {
            msg.push({field: 'industry', error: this.state.resources.industryIsRequired});
        }

        var targetHireDate = this.getFormattedDate("targetHireDate");
        if (util.isStringNullOrEmpty(targetHireDate)) {
            msg.push({field: 'targetHireDate', error: this.state.resources.targetHireDateIsRequired});
        }
        else if (util.isMMDDYYYY(targetHireDate, false) == false) {
            msg.push({field: 'targetHireDate', error: this.state.resources.targetHireDateIsInvalidFormat});
        }

        if (util.isStringNullOrEmpty(request.jobExperience)) {
            msg.push({field: 'jobExperience', error: this.state.resources.jobExperienceIsRequired});
        }

        if (request.numNeeded == null) {
            msg.push({field: 'numNeeded', error: this.state.resources.numNeededIsRequired});
        }

        if (util.isStringNullOrEmpty(request.jobDescription)) {
            msg.push({field: 'jobDescription', error: this.state.resources.jobDescriptionIsRequired});
        }
       
        if (util.isStringNullOrEmpty(request.jobRequirements)) {
            msg.push({field: 'jobRequirements', error: this.state.resources.jobRequirementsIsRequired});
        }

        if (util.isStringNullOrEmpty(request.requiredDegree)) {
            msg.push({field: 'requiredDegree', error: this.state.resources.requiredDegreeIsRequired});
        }

        if (util.isStringNullOrEmpty(request.jobType)) {
            msg.push({field: 'jobType', error: this.state.resources.positionTypeIsRequired});
        }

        if (request.workMonday == false && 
            request.workTuesday == false &&
            request.workWednesday == false &&
            request.workThursday == false &&
            request.workFriday == false &&
            request.workSaturday == false &&
            request.workSunday == false) {
            msg.push({field: 'daysPerWeek', error: this.state.resources.daysPerWeekIsRequired});
        }

        var validStartTime = true;
        if (util.isStringNullOrEmpty(request.startTimeHour)) {
            msg.push({field: 'startTimeHour', error: this.state.resources.workScheduleStartTimeIsRequired});
            validStartTime = false;
        }
        else if (util.isValidTime(request.startTimeHour) == false) {
            msg.push({field: 'startTimeHour', error: this.state.resources.workScheduleStartTimeIsInvalid});
            validStartTime = false;
        }

        var validEndTime = true;
        if (util.isStringNullOrEmpty(request.endTimeHour)) {
            msg.push({field: 'endTimeHour', error: this.state.resources.workScheduleEndTimeIsRequired});
            validEndTime = false;
        }
        else if (util.isValidTime(request.endTimeHour) == false) {
            msg.push({field: 'endTimeHour', error: this.state.resources.workScheduleEndTimeIsInvalid});
            validEndTime = false;
        }

        if (validStartTime == true && validEndTime == true) {
            var startTime = new Date('01/01/2000 ' + request.startTimeHour + ' ' + request.startTimeType)
            var endTime = new Date('01/01/2000 ' + request.endTimeHour + ' ' + request.endTimeType)

            if (endTime <= startTime) {
                msg.push({field: 'workSchedule', error: this.state.resources.workScheduleRangeIsInvalid});
            }
        }

        if (request.exceedsForty == true && util.isStringNullOrEmpty(request.exceedsFortyHours)) {
            msg.push({field: 'exceedsFortyHours', error: this.state.resources.exceedsFortyHoursIsRequired});
        }

        if (request.driversLicense == null) {
            msg.push({field: 'driversLicense', error: this.state.resources.driversLicenseIsRequired});
        }

        if (request.publicTransportation == null) {
            msg.push({field: 'publicTransportation', error: this.state.resources.publicTransportationiIsRequired});
        }

        if (request.replacement == null) {
            msg.push({field: 'replacement', error: this.state.resources.replacementOrNewPositionIsRequired});
        }
        else if (request.replacement == true) {
            if (util.isStringNullOrEmpty(request.replacementFullName)) {
                msg.push({field: 'replacementFullName', error: this.state.resources.whoIsItReplacingIsRequired});
            }
            
            if (util.isStringNullOrEmpty(request.replacementAnnualSalary)) {
                msg.push({field: 'replacementAnnualSalary', error: this.state.resources.predecessorsLastAnnualSalaryIsRequired});
            }
        }
        else if (request.replacement == false) {
            if (util.isStringNullOrEmpty(request.newPositionNotes)) {
                msg.push({field: 'newPositionNotes', error: this.state.resources.newPositionNotesIsRequired});
            }
        }

        if (util.isStringNullOrEmpty(request.salaryMinimum) == false && util.isStringNullOrEmpty(request.salaryMaximum) == false) {
            if (parseFloat(request.salaryMinimum) > parseFloat(request.salaryMaximum)) {
                msg.push({field: 'salaryMaximum', error: this.state.resources.salaryRangeMaximumMustBeGreaterThanSalaryRangeMinimum});
                msg.push({field: 'salaryMinimum', error: ''});
            }
        }

        return msg;
    }

    validateSurvey() {
        var surveys = this.state.request.salarySurveys;

        if (this.role != 'supervisor') {
            for (var i = 0; i < surveys.length; i++) {
                surveys[i].errors = [];
                
                if (util.isStringNullOrEmpty(surveys[i].minSalary) == false && util.isStringNullOrEmpty(surveys[i].maxSalary) == false) {
                    if (parseFloat(surveys[i].minSalary) > parseFloat(surveys[i].maxSalary)) {
                        surveys[i].errors.push({field: 'minSalary', error: this.state.resources.salaryRangeMaximumMustBeGreaterThanSalaryRangeMinimum});
                        surveys[i].errors.push({field: 'maxSalary', error: ''});
                    }
                }
            }
        }

        return surveys;
    }

    getFormattedDate(id) {
        return $('#targetHireDate').next().val().trim(); 
    }

    getButtons() {
        var request = this.state.request;
        var buttons = [];
        var hasReturnToManager = false;
        var hasReturnToHRAdmin = false;
        var hasReturnToManagerEnabled = false;
        var hasReturnToHRAdminEnabled = false;

        switch (this.role) {
            case 'supervisor':
                var buttonsEnabled = false;
                if (this.state.readOnly == false) {
                    if (util.isStringNullOrEmpty(request.status) || request.status == 'SAVED' || request.status == 'RETURNED_MANAGER' || (request.status == 'REQUESTED' && request.viewedByHR == false)) {
                        buttonsEnabled = true;
                    }
                }
                
                buttons.push(<Button id="submit" onClick={() => { this.save('REQUESTED', this.state.resources.requestSubmittedSuccessfully); }} className="btn-info" disabled={!buttonsEnabled}>{this.state.resources.submit}</Button>);
                buttons.push(<Button id="save" onClick={() => { this.save('SAVED', this.state.resources.requestSavedSuccessfully); }} className="btn-info" disabled={!buttonsEnabled}>{this.state.resources.saveForLater}</Button>);
                break;
            case 'hr':
                hasReturnToManager = true;

                if (request.isHRManager == true) {
                    var buttonsEnabled = '';
                    if (request.status == 'REVIEWED' || 
                        request.status == 'RETURNED_HR') {
                        hasReturnToManagerEnabled = true;
                    }

                    buttons.push(<Button id="approved" onClick={() => { 
                        if (this.state.readOnly == true) {
                            this.saveStatus('APPROVED_HR', this.state.resources.requestApprovedSuccessfully); 
                        }
                        else {
                            this.save('APPROVED_HR', this.state.resources.requestApprovedSuccessfully); 
                        }
                    }} className="btn-info" disabled={!hasReturnToManagerEnabled}>{this.state.resources.approve}</Button>);
                    buttons.push(<Button id="reject" onClick={() => { 
                        if (this.state.readOnly == true) {
                            this.saveStatus('REJECTED', this.state.resources.requestRejectedSuccessfully); 
                        }
                        else {
                            this.save('REJECTED', this.state.resources.requestRejectedSuccessfully); 
                        }
                    }} className="btn-info" disabled={!hasReturnToManagerEnabled}>{this.state.resources.reject}</Button>);        
                }
                else {
                    var saveEnabled = false;
                    var reviewedEnabled = false;

                    if (request.status == 'REQUESTED') {
                        if (this.state.readOnly == false) {
                            saveEnabled = true;
                        }

                        if (request.flsaQualified == false) {
                            if ((request.salaryMinimum == null || request.salaryMinimum == '') == false && (request.salaryMaximum == null || request.salaryMaximum == '') == false)
                                reviewedEnabled = true;
                        }
                        else if (request.flsaQualified == true) {
                            if (request.salarySurveys.filter(x => util.isStringNullOrEmpty(x.salarySource) == false && (x.minSalary == null || x.minSalary == '') == false && (x.maxSalary == null || x.maxSalary == '') == false).length > 0) {
                                reviewedEnabled = true;
                            }
                        }   

                        hasReturnToManagerEnabled = true;
                    }
                    
                    buttons.push(<Button id="submit" onClick={() => { 
                        if (this.state.readOnly == true) {
                            this.saveStatus('REVIEWED', this.state.resources.requestReviewedSuccessfully);
                        }
                        else {
                            this.save('REVIEWED', this.state.resources.requestReviewedSuccessfully);
                        }
                     }} className="btn-info" disabled={!reviewedEnabled}>{this.state.resources.reviewed}</Button>);
                    buttons.push(<Button id="save" onClick={() => { this.save('REQUESTED', this.state.resources.requestSavedSuccessfully); }} className="btn-info" disabled={!saveEnabled}>{this.state.resources.save}</Button>);
                }
                
                break;
            case 'exec':
                if (request.status == 'APPROVED_HR') {
                    hasReturnToHRAdminEnabled = true;
                }

                buttons.push(<Button id="approved" onClick={() => { 
                    if (this.state.readOnly == true) {
                        this.saveStatus('APPROVED_EXEC', this.state.resources.requestApprovedSuccessfully);
                    }
                    else {
                        this.save('APPROVED_EXEC', this.state.resources.requestApprovedSuccessfully);
                    }
                }} className="btn-info" disabled={!hasReturnToHRAdminEnabled} >{this.state.resources.approve}</Button>);
                buttons.push(<Button id="reject" onClick={() => { 
                    if (this.state.readOnly == true) {
                        this.saveStatus('REJECTED', this.state.resources.requestRejectedSuccessfully); 
                    }
                    else {
                        this.save('REJECTED', this.state.resources.requestRejectedSuccessfully); 
                    }
                }} className="btn-info" disabled={!hasReturnToHRAdminEnabled} >{this.state.resources.reject}</Button>);

                hasReturnToHRAdmin = true;
                break;
        }

        if ((this.role == 'supervisor' || this.role == 'hr') && (
                (this.state.request.status == 'SOURCING_COMPLETE') ||
                ((this.state.request.postOnInternetJobBoards == false || this.state.request.postOnInternetJobBoards == null) && this.state.request.status == 'APPROVED_EXEC')
            )) {
            buttons.push(<Button id="confirm" onClick={() => { this.setState({ showSuccessfulPlacement: true }); }} className="btn-info" >{this.state.resources.successfulPlacement}</Button>);
            // buttons.push(<Button id="close" onClick={() => { this.setState({ showCloseRequest: true }); }} className="btn-info" >Cancel Request</Button>);
        }
        else if (this.role == 'hr' && request.isHRManager == false && (request.status == 'APPROVED_EXEC' && this.state.request.postOnInternetJobBoards == true)) {
            buttons.push(<Button id="completeSourcing" onClick={() => { this.saveStatus('SOURCING_COMPLETE', this.state.resources.sourcingCompletedSuccessfully); }} className="btn-info" >{this.state.resources.completeSourcing}</Button>);
        }

        if (this.role == 'supervisor' && (request.status == '' || request.status == 'CANCELLED' || request.status == 'EXPIRED' || request.status == 'PLACED') == false) {
            buttons.push(<Button id="close" onClick={() => { this.setState({ showCloseRequest: true }); }} className="btn-info" >{this.state.resources.cancelRequest}</Button>);
        }

        if (buttons.length > 0) {
            buttons.push(<Button id="cancel" onClick={this.onCancelClick} className="btn-info" >{this.state.resources.cancel}</Button>);
        }
        else if (hasReturnToManager == false) {
            buttons.push(<a id="returnToDashBoard" href="javascript:void(0)" onClick={() => { browserHistory.push(context.routeUrl(`${this.role}/prf-main`)); }}>{this.state.resources.returnToDashboard}</a>);
        }

        if (hasReturnToManager == true) {
            buttons.push(<a id="returnToManager" href="javascript:void(0)" onClick={() => {
                if (hasReturnToManagerEnabled == true) {
                    this.setState({
                        showReturnToManager: true
                    });
                }                
             }} className={hasReturnToManagerEnabled == true ? '' : 'ap-link-disabled'} >{this.state.resources.returnToManager}</a>);
        }

        if (hasReturnToHRAdmin == true) {
            buttons.push(<a id="returnToHrAdmin" href="javascript:void(0)" onClick={() => {
                if (hasReturnToHRAdminEnabled == true) {
                    if (this.state.readOnly == true) {
                        this.saveStatus('RETURNED_HR', this.state.resources.requestReturnedToHRVPSuccessfully);
                    }
                    else {
                        this.save('RETURNED_HR', this.state.resources.requestReturnedToHRVPSuccessfully);
                    }
                }
             }} className={hasReturnToHRAdminEnabled == true ? '' : 'ap-link-disabled'}>{this.state.resources.returnToHRVP}</a>);
        }

        return buttons;                        
    }

    save(status, successMessage) {
        var errors = [];
        var surveys = []; 

        errors = this.validate();
        surveys = this.validateSurvey();

        if (surveys.filter(x => x.errors.length > 0).length > 0) {
            errors.push({field: 'externalSalaryComparison', error: this.state.resources.errorInOneOfExternalSalarySurveys})
        }

        if (errors.length > 0) {
            var request = this.state.request;
            request.salarySurveys = surveys;

            this.setState({ 
                errors: errors,
                request: request
            });

            return false;
        }
        else {
            context.message({
                show: true,
                type: "loading",
                message: this.state.resources.savingPleaseWait
            });

            this.setState({
                errors: []
            });

            request = this.state.request;
            request.newStatus = status;
            var prevStatus = this.state.request.status;

            if (request.exceedsForty == false) {
                request.exceedsFortyHours == null;
            }
            
            if (request.replacement == true) {
                request.newPositionNotes = '';
            }
            else {
                request.replacementFullName = '';
                request.replacementAnnualSalary = '';
            }

            if (request.internalCandidate == null || request.internalCandidate == false) {
                request.internalCandidateNames = '';
		        request.internalCandidateJobTitle = '';
		        request.internalCandidateSalary = '';
		        request.internalCandidateJobType = '';
		        request.internalCandidateComments = '';
            }

            const self = this;

            ajax.api()
            .post("save-request", request)
            .then(function (res) {
                var requestId = self.state.request.requestID;
                res.data.salarySurveys.map(function(survey, i) { survey.errors = []; });

                self.setState({
                    readOnly: self.isReadOnly(res.data, false),
                    request: res.data,
                    successMessage: successMessage,
                    isCopy: false
                });
                
                if (self.state.isCopy || requestId == 0) {
                    browserHistory.push(context.routeUrl(`${self.role}/request-entry/${res.data.requestID}`));
                }

                context.message({ show: false });
            })
            .catch(function (err) {
                console.log(err);
                let data = err.response.data;
                if (data.exceptionMessage && data.exceptionMessage.toLowerCase().indexOf("unauthorize") > -1) {
                    browserHistory.push(context.routeUrl(`home`));
                }
                else {
                    if (data.exceptionMessage && data.exceptionMessage.toLowerCase().indexOf("request current status is invalid for this action") > -1) {
                        setTimeout(function() {
                            window.location.href = window.location.href;
                        }, 2000);
                    }
                    
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                }
            });
        }
    }

    saveStatus(status, successMessage, notes) {
        context.message({
            show: true,
            type: "loading",
            message: this.state.resources.savingPleaseWait
        });

        const self = this;

        var request = this.state.request;
        request.newStatus = status;
        request.activityNotes = notes;

        ajax.api()
        .post("save-request-status", request)
        .then(function (res) {
            self.setState({
                readOnly: self.isReadOnly(res.data, false),
                request: res.data,
                successMessage: successMessage,
                isCopy: false,
                showReturnToManager: false,
                showCloseRequest: false,
                showSuccessfulPlacement: false
            });

            browserHistory.push(context.routeUrl(`${self.role}/request-entry/${request.requestID}`));

            context.message({ show: false });
        })
        .catch(function (err) {
            console.log(err);
            let data = err.response.data;
            if (data.exceptionMessage && data.exceptionMessage.toLowerCase().indexOf("unauthorize") > -1) {
                browserHistory.push(context.routeUrl(`home`));
            }
            else
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
        });
    }

    saveNotes(notes) {
        context.message({
            show: true,
            type: "loading",
            message: this.state.resources.savingPleaseWait
        });

        const self = this;

        var request = this.state.request;
        
        if (this.state.showNotesType == 'notes') {
            request.notes = notes;
        }
        else {
            request.hrNotes = notes;
        }

        ajax.api()
        .post("save-request-notes", request)
        .then(function (res) {
            self.setState({
                request: request,
                successMessage: self.state.resources.notesSavedSuccessfully,
                showNotes: false
            });

            context.message({ show: false });
        })
        .catch(function (err) {
            console.log(err);
            let data = err.response.data;
            if (data.exceptionMessage && data.exceptionMessage.toLowerCase().indexOf("unauthorize") > -1) {
                browserHistory.push(context.routeUrl(`home`));
            }
            else
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
        });
    }
        
    onCancelClick() {
        browserHistory.push(context.routeUrl(`${this.role}/prf-main`));
    }

    onApplicantLogClick() {
        browserHistory.push(context.routeUrl(`${this.role}/applicant-log-main/${this.state.request.requestID}`));
    }

    isReadOnly(request, load) {
        if (this.role == 'supervisor') {
            return ((request.status == null || 
                    request.status == '' || 
                    request.status == 'SAVED' || 
                    request.status == 'RETURNED_MANAGER' || 
                    (request.status == 'REQUESTED' && request.viewedByHR == false)) == false)
        }
        else if (this.role == 'hr' && request.isHRManager == false && load == false) {
            return request.status != 'REQUESTED';
        }
        else if (this.role == 'hr' && request.isHRManager == true && load == false) {
            return (request.status == 'REQUESTED' || request.status == 'REVIEWED') == false;
        }
        else if (this.role == 'exec' && load == false) {
            return request.status != 'APPROVED_HR';
        }

        return this.state.readOnly;
    }

    getLinks() {
        var links =  [];
        links.push({ name: this.state.resources.home, link: context.routeUrl('home'), active: true });
        links.push({ name: this.state.resources.positionRequisition, link: context.routeUrl(`${this.role}/prf-main`), active: true });

        if (this.state.isCopy == true ) {
            links.push({ name: this.state.resources.copyRequest, link: '#', active: false });
        }
        else if (this.state.request.requestID == 0) {
            links.push({ name: this.state.resources.newRequest, link: '#', active: false });
        }
        else {
            links.push({ name: 'Req. ' + this.state.request.requestID + ' (' + this.state.request.positionTitle + ')', link: '#', active: false });
        }
        
        return links;
    }

    showPrfSubmitted() {
        return (this.state.request.status == 'REQUESTED' || 
                this.state.request.status == 'REVIEWED' ||
                this.state.request.status == 'APPROVED_HR' ||
                this.state.request.status == 'RETURNED_HR' || 
                this.state.request.status == 'APPROVED_EXEC' ||
                this.state.request.status == 'SOURCING_COMPLETE') == false
    }

    showRequestedBy() {
        return (this.state.request.status == null || this.state.request.status == 'SAVED' || this.state.request.status == 'RETURNED_MANAGER') == false;
    }

    getButtonMessage() {
        if (this.role == 'hr' && this.state.request.isHRManager == false && this.state.request.status == 'REQUESTED') {
            return this.state.resources.forHRVPApprovalButtonMessage;
        }
        else if (this.role == 'hr' && this.state.request.isHRManager == true && (this.state.request.status == 'REVIEWED' || this.state.request.status == 'RETURNED_HR')) {
            return this.state.resources.forExecApprovalButtonMessage;
        }
        else if (this.role == 'exec' && this.state.request.status == 'APPROVED_HR') {
            return this.state.resources.requestApprovedButtonMessage;
        }

        return "";
    }

    showEdit() {
        return this.state.readOnly == true &&
            (
                (this.role == 'hr' && this.state.request.status == 'REQUESTED' && this.state.request.isHRManager == false) ||
                (this.role == 'hr' && (this.state.request.status == 'REVIEWED' || this.state.request.status == 'RETURNED_HR') && this.state.request.isHRManager == true) ||
                (this.role == 'exec' && this.state.request.status == 'APPROVED_HR')
            );
    }

    getRequiredControl() {
        return <span className={"required " + (this.state.readOnly == true ? 'ap-hidden' : '')}>*</span>
    }

    showApplicantLog() {
        return (this.role == 'supervisor' || this.role == 'hr') && 
            (this.state.request.status == 'APPROVED_EXEC' || 
            this.state.request.status == 'SOURCING_COMPLETE' || 
            this.state.request.status == 'PLACED');
    }

    render() {
        if (this.state.request == null) {
            return <div className="container"></div>
        }

        var readOnly = this.state.readOnly;
        var buttonMessage = this.getButtonMessage();

        if (this.role != 'supervisor') {
            const self = this;
            var externalSalaryComparison = [];
            this.state.request.salarySurveys.map(function (item, i) {
                externalSalaryComparison.push(
                    <SalarySurvey
                        id='externalSalaryComparison'
                        data={item}
                        onChange={this.onExternalSalaryComparison}
                        onRemove={this.onExternalSalaryComparisonRemove}
                        readOnly={readOnly}>
                    </SalarySurvey>);
                
                if (i < (self.state.request.salarySurveys.length - 1)) 
                    externalSalaryComparison.push(<hr className="ap-hr-normal" style={{ "marginTop" : "10px !important" }} />);
            }, this); 
        }

        var errors = [];
        this.state.errors.map(function (item, i) {
            if (item.error.length > 0) {
                errors.push(<li key={item.field}>{item.error}</li>);
            }
        });

        return (
            <div style={{ "backgroundColor" : "rgb(239, 239, 239)" }}>
                <Modal show={this.state.showReturnToManager} backdrop='static' dialogClassName="ap-request-modal" 
                    onHide={() => this.setState({ showReturnToManager: false})}>
                    <Modal.Header closeButton={true}>
                        <h4>{this.state.resources.returnToManager}</h4>
                    </Modal.Header>
                    <Modal.Body className="ap-dialog-body">
                        <div>
                            <div className="row">
                                <div className="col-md-12 col-lg-12">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.returnToManagerReason}: <span className="required">*</span></ControlLabel>
                                    <FormControl 
                                        id="reasonForReturn"
                                        componentClass="textarea"
                                        rows="5"
                                        inputRef={ref => this.reasonForReturn = ref}>
                                    </FormControl>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">
                                    <Button onClick={() => { 
                                        if (this.reasonForReturn != null) {
                                            this.reasonForReturn.className = this.reasonForReturn.className.replace('ap-report-control-error', '');
                                            if (this.reasonForReturn.value.trim() == '') {
                                                this.reasonForReturn.className = this.reasonForReturn.className + ' ' + 'ap-report-control-error';
                                            }
                                            else {
                                                this.saveStatus('RETURNED_MANAGER', this.state.resources.returnToManagerSuccess, this.reasonForReturn.value); 
                                            }
                                        }
                                    }} className="btn btn-info ap-fullsize">{this.state.resources.send}</Button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={this.state.showSuccessfulPlacement} backdrop='static' dialogClassName="ap-request-modal" 
                    onHide={() => this.setState({ showSuccessfulPlacement: false})}>
                    <Modal.Header closeButton={true}>
                        <h4>{this.state.resources.successfulPlacement}</h4>
                    </Modal.Header>
                    <Modal.Body className="ap-dialog-body">
                        <div>
                            <div className="row">
                                <div className="col-md-12 col-lg-12">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.successfulPlacementMessage}</ControlLabel>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-md-2 col-lg-2"></div>
                                <div className="col-md-4 col-lg-4">
                                    <Button onClick={() => { this.saveStatus('PLACED', this.state.resources.successfulPlacementSuccess, '', false); }} className="btn btn-info ap-fullsize">{this.state.resources.confirm}</Button>
                                </div>
                                <div className="col-md-4 col-lg-4">
                                    <Button onClick={() => { this.setState({ showSuccessfulPlacement: false }) }} className="btn btn-info ap-fullsize">{this.state.resources.cancel}</Button>
                                </div>
                                <div className="col-md-2 col-lg-2"></div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={this.state.showCloseRequest} backdrop='static' dialogClassName="ap-request-modal" 
                    onHide={() => this.setState({ showCloseRequest: false})}>
                    <Modal.Header closeButton={true}>
                        <h4>{this.state.resources.cancelRequest}</h4>
                    </Modal.Header>
                    <Modal.Body className="ap-dialog-body">
                        <div>
                            <div className="row">
                                <div className="col-md-12 col-lg-12">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.cancelRequestMessage}</ControlLabel>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-md-8 col-lg-8">
                                    <Button onClick={() => { this.saveStatus('CANCELLED', this.state.resources.cancelRequestSuccess, '', false); }} className="btn btn-info ap-fullsize">{this.state.resources.cancelRequestYes}</Button>
                                </div>
                                <div className="col-md-4 col-lg-4">
                                    <Button onClick={() => { this.setState({ showCloseRequest: false }) }} className="btn btn-info ap-fullsize">{this.state.resources.cancel}</Button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={this.state.showNotes} backdrop='static' dialogClassName="ap-request-modal" 
                    onHide={() => this.setState({ showNotes: false, showNotesType: '' })}>
                    <Modal.Header closeButton={true}>
                        <h4>{this.state.resources.addEditNotes}</h4>
                    </Modal.Header>
                    <Modal.Body className="ap-dialog-body">
                        <div>
                            <div className="row">
                                <div className="col-md-12 col-lg-12">
                                    <FormControl 
                                        id="editNotes"
                                        componentClass="textarea"
                                        rows="5"
                                        inputRef={ref => this.editNotes = ref}
                                        defaultValue={this.state.showNotesType == 'notes' ? this.state.request.notes : this.state.request.hrNotes }>
                                    </FormControl>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">
                                    <Button onClick={() => { 
                                        this.saveNotes(this.editNotes.value)
                                    }} className="btn btn-info ap-fullsize">{this.state.resources.save}</Button>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <Navigation links={this.getLinks()} />
                        </div>
                        <div className={"col-md-2 " + (this.showApplicantLog() ? '' : 'ap-hidden')}>
                            <Button id="applicantLog" onClick={this.onApplicantLogClick} className="btn-info" >{this.state.resources.applicantLog}</Button>
                        </div>
                        <div className="col-md-4">

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            <div className={"ap-white-background " + (this.showPrfSubmitted() ? "ap-hidden" : "")} style={{ "marginBottom" : "10px", "padding": "10px" }}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div style={{ "textAlign": "center"}}>
                                            <span className="fa fa-check-circle ap-green-color"/>
                                            <ControlLabel className="ap-report-control-label ap-5-margin-left" style={{ "fontSize": "14px !important"}}>{this.state.resources.prfSubmitted} </ControlLabel>
                                        </div>
                                    </div>
                                </div>
                                <div className="row hidden-sm hidden-xs">
                                    <div className="col-md-12">
                                        <ControlLabel>
                                            <div dangerouslySetInnerHTML={ { __html: this.state.resources.prfSubmittedMessage } }>
                                            </div>
                                        </ControlLabel>
                                    </div>
                                </div>
                            </div>
                            <div className="ap-white-background" style={{ "padding": "10px" }}>
                                <div className={"row " + (this.showEdit() == false ? 'ap-hidden' : '')}>
                                    <div className="col-md-12">
                                        <span className="fa fa-edit ap-green-color pull-right" onClick={() => { this.setState({ readOnly: false }) }}></span>
                                    </div>
                                </div>
                                <div className={"row " + (this.showRequestedBy() == false ? 'ap-hidden' : '' )}>
                                    <div className="col-md-12">
                                        <div style={{ "textAlign": "center" }}>
                                            <span className="fa fa-check-circle ap-green-color"/>
                                            <ControlLabel className="ap-report-control-label ap-5-margin-left">{this.state.resources.requestedBy} </ControlLabel>
                                            <ControlLabel className="ap-report-control-label ap-black-color ap-5-margin-left">{this.state.request.hiringManagerFullName}</ControlLabel>
                                        </div>
                                    </div>
                                </div>
                                <div className={"row " + (readOnly == true ? "ap-hidden" : "")}>
                                    <div className="col-md-12">
                                        <ControlLabel className="pull-right"><span className="required">* {this.state.resources.required}</span></ControlLabel>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.hiringManager}: {this.getRequiredControl()}</ControlLabel>
                                        {
                                            readOnly == false ? 
                                                <FormControl 
                                                    id="hiringManager"
                                                    type="text" 
                                                    value={this.state.request.hiringManagerFullName}
                                                    readOnly={true}>
                                                </FormControl> : 
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.hiringManagerFullName}</ControlLabel></div>
                                        }
                                    </div>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.company}: {this.getRequiredControl()}</ControlLabel>
                                        <Company 
                                            id="company" 
                                            value={this.state.request.company} 
                                            onChange={this.onCompanyChange} 
                                            allText={this.state.resources.selectCompany}
                                            className={this.getErrorClass('company')}
                                            readOnly={readOnly} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.costCenter}: {this.getRequiredControl()}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <Office 
                                                    id="office" 
                                                    value={this.state.request.office} 
                                                    onChange={this.onCostCenterChange} 
                                                    allText={this.state.resources.selectCostCenter}
                                                    useCode={true}
                                                    className={this.getErrorClass('office')}
                                                    readOnly={readOnly} /> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.office}</ControlLabel></div>
                                        }
                                        
                                    </div>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.officeName}: {this.getRequiredControl()}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <FormControl 
                                                    id="officeName"
                                                    type="text" 
                                                    readOnly={true}
                                                    value={this.state.request.officeName}
                                                    className={this.getErrorClass('office')}>
                                                </FormControl> : 
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.officeName}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.deptHeadCount}: {this.getRequiredControl()}</ControlLabel> 
                                        {
                                            readOnly == false ?
                                                <FormControl 
                                                    id="deptHeadCount"
                                                    type="text" 
                                                    value={this.state.request.deptHeadCount}
                                                    onChange={this.onNumberChange}
                                                    maxLength="7" 
                                                    className={this.getErrorClass('deptHeadCount')}
                                                    readOnly={readOnly}>
                                                </FormControl> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.deptHeadCount}</ControlLabel></div>
                                        }
                                    </div>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.ccMySupervisor}: </ControlLabel> 
                                        {
                                            readOnly == false ?
                                                <FormControl 
                                                    id="ccEmailAddress"
                                                    type="text" 
                                                    value={this.state.request.ccEmailAddress}
                                                    onChange={this.onFormControlChange}
                                                    className={this.getErrorClass('ccEmailAddress')}
                                                    readOnly={readOnly}
                                                    maxLength="200">
                                                </FormControl> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.ccEmailAddress}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-control-header-label">{this.state.resources.physicalReportingLocation}</ControlLabel>
                                    </div>
                                </div>
                                <hr className="ap-hr-normal" />
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.streetAddress}: {this.getRequiredControl()}</ControlLabel> 
                                        {
                                            readOnly == false ?
                                                <FormControl 
                                                    id="reportToAddress"
                                                    type="text" 
                                                    value={this.state.request.reportToAddress}
                                                    onChange={this.onFormControlChange}
                                                    maxLength="50" 
                                                    className={this.getErrorClass('reportToAddress')}
                                                    readOnly={readOnly}>
                                                </FormControl> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.reportToAddress}</ControlLabel></div>
                                        }
                                    </div>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.city}: {this.getRequiredControl()}</ControlLabel> 
                                        {
                                            readOnly == false ?
                                                <FormControl 
                                                    id="reportToCity"
                                                    type="text" 
                                                    value={this.state.request.reportToCity}
                                                    onChange={this.onFormControlChange}
                                                    maxLength="50" 
                                                    className={this.getErrorClass('reportToCity')}
                                                    readOnly={readOnly}>
                                                </FormControl> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.reportToCity}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.state}: {this.getRequiredControl()}</ControlLabel> 
                                        {
                                            readOnly == false ?
                                                <State 
                                                    id="reportToState" 
                                                    value={this.state.request.reportToState} 
                                                    onChange={this.onValueChange} 
                                                    allText={this.state.resources.pleaseSelect}
                                                    className={this.getErrorClass('reportToState')}
                                                    readOnly={readOnly}
                                                    country={this.state.request.reportToCountry}
                                                    dataKey="reportToState" /> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.reportToState}</ControlLabel></div>
                                        }
                                    </div>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.zipCode}: {this.getRequiredControl()}</ControlLabel> 
                                        {
                                            readOnly == false ?
                                                <StringAutoComplete
                                                    id="reportToZipCode" 
                                                    value={this.state.request.reportToZipCode}
                                                    url="get-zip-codes-by-prefix"
                                                    rows={10}
                                                    valueFields={[{'field':'postalCode','header':'Code'},
                                                                {'field':'cityName','header':'City'},
                                                                {'field':'provinceAbbr','header':'State'},
                                                                {'field':'countryName','header':'Country'}]}
                                                    valueField="postalCode"
                                                    onSelect={this.onZipCodeChange}
                                                    readOnly={readOnly}
                                                    maxLength={32}
                                                    allowedLength={9}
                                                    dataKey="reportToZipCode"
                                                    className={this.getErrorClass('reportToZipCode')} /> 
                                                    :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.reportToZipCode}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.country}: {this.getRequiredControl()}</ControlLabel> 
                                        {
                                            readOnly == false ?
                                                <CodeList 
                                                id="reportToCountry" 
                                                value={this.state.request.reportToCountry} 
                                                onChange={this.onValueChange} 
                                                category="COUNTRY"
                                                allText={this.state.resources.pleaseSelect}
                                                readOnly={readOnly}
                                                className={this.getErrorClass('reportToCountry')}
                                                onAfterChange={this.onReportCountryChange} /> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.reportToCountry}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <Checkbox 
                                            id="virtual"
                                            onChange={this.onCheckBoxChange}
                                            checked={this.state.request.virtual}
                                            disabled={readOnly}>
                                            <ControlLabel className="ap-report-control-label" style={{ "paddingLeft" : "0px" }}>{this.state.resources.virtual} <span className="ap-control-sub-label">({this.state.resources.workingRemotely})</span></ControlLabel>
                                        </Checkbox>
                                    </div>
                                    <div className="col-md-8">
                                        <Checkbox 
                                            id="hybrid"
                                            onChange={this.onCheckBoxChange}
                                            checked={this.state.request.hybrid}
                                            disabled={readOnly}>
                                            <ControlLabel className="ap-report-control-label" style={{ "paddingLeft" : "0px" }}>{this.state.resources.hybrid} <span className="ap-control-sub-label">({this.state.resources.hybridMessage})</span></ControlLabel>
                                        </Checkbox>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.city}: {this.getRequiredControl()}</ControlLabel> 
                                        {
                                            readOnly == false ?
                                                <FormControl 
                                                    id="remoteCity"
                                                    type="text" 
                                                    value={this.state.request.remoteCity}
                                                    onChange={this.onFormControlChange}
                                                    maxLength="50" 
                                                    className={this.getErrorClass('remoteCity')}
                                                    readOnly={readOnly}>
                                                </FormControl> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.remoteCity}</ControlLabel></div>
                                        }
                                    </div>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.state}: {this.getRequiredControl()}</ControlLabel> 
                                        {
                                            readOnly == false ?
                                                <State 
                                                    id="remoteState" 
                                                    value={this.state.request.remoteState} 
                                                    onChange={this.onValueChange} 
                                                    allText={this.state.resources.pleaseSelect}
                                                    className={this.getErrorClass('remoteState')}
                                                    readOnly={readOnly}
                                                    country={this.state.request.remoteCountry}
                                                    dataKey="remoteState" /> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.remoteState}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.country}: {this.getRequiredControl()}</ControlLabel> 
                                        {
                                            readOnly == false ?
                                                <CodeList 
                                                    id="remoteCountry" 
                                                    value={this.state.request.remoteCountry} 
                                                    onChange={this.onValueChange} 
                                                    category="COUNTRY"
                                                    allText={this.state.resources.pleaseSelect}
                                                    readOnly={readOnly}
                                                    className={this.getErrorClass('remoteCountry')} /> :
                                                    <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.remoteCountry}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-control-header-label">{this.state.resources.positionDetails}</ControlLabel>
                                    </div>
                                </div>
                                <hr className="ap-hr-normal" />
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.divisionCompanySector}: {this.getRequiredControl()}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <div className={"row + " + this.getErrorClass('division')}>
                                                    <div className="col-md-6">
                                                        <Button 
                                                            id="divisionStaffing"
                                                            className={"btn-info ap-fullsize " + (this.state.request.division == "Staffing" ? "btn-selected" : "")}
                                                            onClick={this.onDivisionClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.staffing}
                                                        </Button>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <OverlayTrigger id="requestentry_nonStaffingCorporate"
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id="tooltip_nonStaffingCorporate" className="ap-tooltip">{this.state.resources.nonStaffingCorporate}</Tooltip>
                                                            } >
                                                            <Button 
                                                                id="divisionOther"
                                                                className={"btn-info ap-fullsize " + (this.state.request.division == "Other" ? "btn-selected" : "")}
                                                                onClick={this.onDivisionClick}
                                                                disabled={readOnly}>
                                                                {this.state.resources.other}
                                                            </Button>
                                                        </OverlayTrigger>
                                                    </div>
                                                </div> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.division}</ControlLabel></div>
                                        }
                                    </div>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.reportsTo}: {this.getRequiredControl()}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <FormControl 
                                                    id="reportToFullName"
                                                    type="text" 
                                                    value={this.state.request.reportToFullName}
                                                    onChange={this.onFormControlChange}
                                                    maxLength="100"
                                                    className={this.getErrorClass('reportToFullName')} 
                                                    readOnly={readOnly}>
                                                </FormControl> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.reportToFullName}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.positionTitle}: {this.getRequiredControl()}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <FormControl 
                                                    id="positionTitle"
                                                    type="text" 
                                                    value={this.state.request.positionTitle}
                                                    onChange={this.onFormControlChange}
                                                    maxLength="100"
                                                    className={this.getErrorClass('positionTitle')} 
                                                    readOnly={readOnly}>
                                                </FormControl> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.positionTitle}</ControlLabel></div>
                                        }
                                    </div>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.industryField}: {this.getRequiredControl()}</ControlLabel>
                                        <IndustryCategory
                                            id="industry" 
                                            value={this.state.request.industry} 
                                            onChange={this.onValueChange} 
                                            allText="Please Select"
                                            readOnly={readOnly}
                                            className={this.getErrorClass('industry')} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.targetHireDate}: {this.getRequiredControl()}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <DatePicker 
                                                    id="targetHireDate"
                                                    placeholder="MM/DD/YYYY" 
                                                    value={this.state.request.targetHireDate}
                                                    onChange={this.onTargetHireDateChange} 
                                                    className={this.getErrorClass('targetHireDate')}
                                                    disabled={readOnly}/> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{moment(this.state.request.targetHireDate).format("MM/DD/YYYY")}</ControlLabel></div>
                                        }
                                    </div>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.jobExperience}: {this.getRequiredControl()}</ControlLabel>
                                        <CodeList 
                                            id="jobExperience" 
                                            value={this.state.request.jobExperience} 
                                            onChange={this.onValueChange} 
                                            category="EXPERIENCE_LEVEL"
                                            allText={this.state.resources.pleaseSelect}
                                            readOnly={readOnly}
                                            className={this.getErrorClass('jobExperience')} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.numNeeded}: {this.getRequiredControl()}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <FormControl 
                                                    id="numNeeded"
                                                    type="text" 
                                                    value={this.state.request.numNeeded}
                                                    onChange={this.onNumberChange}
                                                    maxLength="2"
                                                    className={this.getErrorClass('numNeeded')} 
                                                    readOnly={readOnly}>
                                                </FormControl> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.numNeeded}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.jobDescription}: {this.getRequiredControl()}</ControlLabel>
                                        <FormControl 
                                            id="jobDescription"
                                            componentClass="textarea"
                                            rows="5"
                                            value={this.state.request.jobDescription}
                                            onChange={this.onFormControlChange}
                                            className={this.getErrorClass('jobDescription') + (readOnly == true ? " ap-report-control-label ap-black-color ap-white-background" : "")} 
                                            readOnly={readOnly}>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.jobRequirements}: {this.getRequiredControl()}</ControlLabel>
                                        <FormControl 
                                            id="jobRequirements"
                                            componentClass="textarea"
                                            rows="5"
                                            value={this.state.request.jobRequirements}
                                            onChange={this.onFormControlChange}
                                            className={this.getErrorClass('jobRequirements') + (readOnly == true ? " ap-report-control-label ap-black-color ap-white-background" : "")} 
                                            readOnly={readOnly}>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.positionType}: {this.getRequiredControl()}</ControlLabel>
                                        <CodeList 
                                            id="jobType" 
                                            value={this.state.request.jobType} 
                                            onChange={this.onValueChange} 
                                            category="EMPLOYMENT_TYPE"
                                            allText="Please Select"
                                            readOnly={readOnly}
                                            className={this.getErrorClass('jobType')} />
                                    </div>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.requiredDegree}: {this.getRequiredControl()}</ControlLabel>
                                        <CodeList 
                                            id="requiredDegree" 
                                            value={this.state.request.requiredDegree} 
                                            onChange={this.onValueChange} 
                                            category="DEGREE_CODE"
                                            allText="Please Select"
                                            readOnly={readOnly}
                                            className={this.getErrorClass('requiredDegree')} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.daysPerWeek}: {this.getRequiredControl()}</ControlLabel>
                                        <div className={"row " + this.getErrorClass('daysPerWeek')}>
                                            <div className="col-md-12">
                                                <Checkbox 
                                                    id="workMonday"
                                                    onChange={this.onCheckBoxChange}
                                                    checked={this.state.request.workMonday}
                                                    disabled={readOnly}
                                                    inline>
                                                    <ControlLabel className="ap-report-control-label" style={{ "paddingLeft" : "0px" }}>M</ControlLabel>
                                                </Checkbox>
                                                <Checkbox 
                                                    id="workTuesday"
                                                    onChange={this.onCheckBoxChange}
                                                    checked={this.state.request.workTuesday}
                                                    disabled={readOnly}
                                                    inline>
                                                    <ControlLabel className="ap-report-control-label" style={{ "paddingLeft" : "0px" }}>TU</ControlLabel>
                                                </Checkbox>
                                                <Checkbox 
                                                    id="workWednesday"
                                                    onChange={this.onCheckBoxChange}
                                                    checked={this.state.request.workWednesday}
                                                    disabled={readOnly}
                                                    inline>
                                                    <ControlLabel className="ap-report-control-label" style={{ "paddingLeft" : "0px" }}>W</ControlLabel>
                                                </Checkbox>
                                                <Checkbox 
                                                    id="workThursday"
                                                    onChange={this.onCheckBoxChange}
                                                    checked={this.state.request.workThursday}
                                                    disabled={readOnly}
                                                    inline>
                                                    <ControlLabel className="ap-report-control-label" style={{ "paddingLeft" : "0px" }}>TH</ControlLabel>
                                                </Checkbox>
                                                <Checkbox 
                                                    id="workFriday"
                                                    onChange={this.onCheckBoxChange}
                                                    checked={this.state.request.workFriday}
                                                    disabled={readOnly}
                                                    inline>
                                                    <ControlLabel className="ap-report-control-label" style={{ "paddingLeft" : "0px" }}>F</ControlLabel>
                                                </Checkbox>
                                                <Checkbox 
                                                    id="workSaturday"
                                                    onChange={this.onCheckBoxChange}
                                                    checked={this.state.request.workSaturday}
                                                    disabled={readOnly}
                                                    inline>
                                                    <ControlLabel className="ap-report-control-label" style={{ "paddingLeft" : "0px" }}>SA</ControlLabel>
                                                </Checkbox>
                                                <Checkbox 
                                                    id="workSunday"
                                                    onChange={this.onCheckBoxChange}
                                                    checked={this.state.request.workSunday}
                                                    disabled={readOnly}
                                                    inline>
                                                    <ControlLabel className="ap-report-control-label" style={{ "paddingLeft" : "0px" }}>SU</ControlLabel>
                                                </Checkbox>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.workSchedule}: {this.getRequiredControl()}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <div className={"work-schedule " + this.getErrorClass('workSchedule')}>
                                                    <span className="work-schedule start">
                                                        <span>
                                                            <FormControl 
                                                                id="startTimeHour"
                                                                name="startTime"
                                                                type="text" 
                                                                value={this.state.request.startTimeHour}
                                                                onChange={this.onTimeChange}
                                                                className={this.getErrorClass('startTimeHour')}>
                                                            </FormControl>
                                                        </span>
                                                        <span>
                                                            <FormControl
                                                                id="startTimeType"
                                                                name="startTime"
                                                                componentClass="select"
                                                                value={this.state.request.startTimeType}
                                                                onChange={this.onFormControlChange}>
                                                                <option key="AM" value="AM">am</option>
                                                                <option key="PM" value="PM">pm</option>
                                                            </FormControl>
                                                        </span>
                                                    </span>
                                                    <span className="work-schedule arrow">
                                                        <i className="glyphicon glyphicon-arrow-right"></i>
                                                    </span>
                                                    <span className="work-schedule end">
                                                        <span>
                                                            <FormControl 
                                                                id="endTimeHour"
                                                                name="endTime"
                                                                type="text" 
                                                                value={this.state.request.endTimeHour}
                                                                onChange={this.onTimeChange}
                                                                className={this.getErrorClass('endTimeHour')}>
                                                            </FormControl>
                                                        </span>
                                                        <span>
                                                            <FormControl
                                                                id="endTimeType"
                                                                name="endTime"
                                                                componentClass="select"
                                                                value={this.state.request.endTimeType}
                                                                onChange={this.onFormControlChange}>
                                                                <option key="AM" value="AM">am</option>
                                                                <option key="PM" value="PM">pm</option>
                                                            </FormControl>
                                                        </span>
                                                    </span>
                                                </div> : 
                                                <div>
                                                    <ControlLabel className="ap-report-control-label ap-black-color">
                                                        {
                                                            (this.state.request.startTimeHour + ' ' + this.state.request.startTimeType) +
                                                            ' - ' +
                                                            (this.state.request.endTimeHour + ' ' + this.state.request.endTimeType)
                                                        }
                                                    </ControlLabel>
                                                </div>
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.exceedsFortyMessage} {this.getRequiredControl()}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <Button 
                                                            id="exceedsFortyYes"
                                                            name="exceedsForty"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('exceedsForty', true)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.yes}
                                                        </Button>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <Button 
                                                            id="exceedsFortyNo"
                                                            name="exceedsForty"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('exceedsForty', false)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.no}
                                                        </Button>
                                                    </div> 
                                                </div> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.getYesNoButtonValue('exceedsForty')}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className={"row " + (this.state.request.exceedsForty == false ? "ap-hidden" : "")}>
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.exceedsFortyHoursMessage}: {this.getRequiredControl()}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <FormControl 
                                                            id="exceedsFortyHours"
                                                            type="text" 
                                                            value={this.state.request.exceedsFortyHours}
                                                            onChange={this.onNumberChange}
                                                            maxLength="10"
                                                            className={this.getErrorClass('exceedsFortyHours')} 
                                                            readOnly={readOnly}>
                                                        </FormControl>
                                                    </div>
                                                </div> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.replacementAnnualSalary}</ControlLabel></div>
                                        }
                                        
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.driversLicenseMessage} {this.getRequiredControl()}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <div className={"row + " + this.getErrorClass('driversLicense')}>
                                                    <div className="col-md-6">
                                                        <Button 
                                                            id="driversLicenseYes"
                                                            name="driversLicense"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('driversLicense', true)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.yes}
                                                        </Button>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <Button 
                                                            id="driversLicenseNo"
                                                            name="driversLicense"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('driversLicense', false)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.no}
                                                        </Button>
                                                    </div> 
                                                </div> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.getYesNoButtonValue('driversLicense')}</ControlLabel></div>
                                        }
                                    </div>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.publicTransportationMessage} {this.getRequiredControl()}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <div className={"row " + this.getErrorClass('publicTransportation')}>
                                                    <div className="col-md-6">
                                                        <Button 
                                                            id="publicTransportationYes"
                                                            name="publicTransportation"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('publicTransportation', true)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.yes}
                                                        </Button>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <Button 
                                                            id="publicTransportationNo"
                                                            name="publicTransportation"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('publicTransportation', false)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.no}
                                                        </Button>
                                                    </div> 
                                                </div> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.getYesNoButtonValue('publicTransportation')}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.replacementOrNewPosition} {readOnly == true ? '' : <span><span className="required">*</span> - <span className="ap-control-sub-label">({this.state.resources.pleaseSelectOne})</span></span>}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <div className={"row " + this.getErrorClass('replacement')}>
                                                    <div className="col-md-6">
                                                        <Button 
                                                            id="replacementYes"
                                                            name="replacement"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('replacement', true)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.replacement}
                                                        </Button>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <Button 
                                                            id="replacementNo"
                                                            name="replacement"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('replacement', false)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.newPosition}
                                                        </Button>
                                                    </div> 
                                                </div> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.replacement == true ? "Replacement" : "New Position"}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className={"row " + (this.state.request.replacement == false || this.state.request.replacement == null ? "ap-hidden" : "")}>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.whoIsItReplacing} {this.getRequiredControl()}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <FormControl 
                                                    id="replacementFullName"
                                                    type="text" 
                                                    value={this.state.request.replacementFullName}
                                                    onChange={this.onFormControlChange}
                                                    maxLength="100"
                                                    className={this.getErrorClass('replacementFullName')} 
                                                    readOnly={readOnly}>
                                                </FormControl> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.replacementFullName}</ControlLabel></div>
                                        }
                                        
                                    </div>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.predecessorsLastAnnualSalary} {this.getRequiredControl()}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <FormControl 
                                                    id="replacementAnnualSalary"
                                                    type="text" 
                                                    value={this.state.request.replacementAnnualSalary}
                                                    onChange={this.onSalaryChange}
                                                    maxLength="10"
                                                    className={this.getErrorClass('replacementAnnualSalary')} 
                                                    readOnly={readOnly}>
                                                </FormControl> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.replacementAnnualSalary}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className={"row " + (this.state.request.replacement == true || this.state.request.replacement == null ? "ap-hidden" : "")}>
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.newPositionNotes}: {this.getRequiredControl()}</ControlLabel>
                                        <FormControl 
                                            id="newPositionNotes"
                                            componentClass="textarea"
                                            rows="5"
                                            value={this.state.request.newPositionNotes}
                                            onChange={this.onFormControlChange}
                                            className={this.getErrorClass('newPositionNotes')}
                                            readOnly={readOnly}
                                            className={readOnly == true ? "ap-report-control-label ap-black-color ap-white-background" : "" }>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.proposedIncentivePlan}: {readOnly == true ? '' : <span className="ap-control-sub-label">({this.state.resources.proposedIncentivePlanMessage})</span>}</ControlLabel>
                                        <FormControl 
                                            id="incentivePlan"
                                            componentClass="textarea"
                                            rows="5"
                                            value={this.state.request.incentivePlan}
                                            onChange={this.onFormControlChange}
                                            readOnly={readOnly}
                                            className={readOnly == true ? "ap-report-control-label ap-black-color ap-white-background" : "" }>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.bonusProgram}:</ControlLabel>
                                        <FormControl 
                                            id="bonusProgram"
                                            componentClass="textarea"
                                            rows="5"
                                            value={this.state.request.bonusProgram}
                                            onChange={this.onFormControlChange}
                                            readOnly={readOnly}
                                            className={readOnly == true ? "ap-report-control-label ap-black-color ap-white-background" : "" }>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.notes}:</ControlLabel>
                                        <FormControl 
                                            id="notes"
                                            componentClass="textarea"
                                            rows="5"
                                            value={this.state.request.notes}
                                            onChange={this.onFormControlChange}
                                            readOnly={readOnly}
                                            className={readOnly == true ? "ap-report-control-label ap-black-color ap-white-background" : "" }>
                                        </FormControl>
                                        {
                                            readOnly == true ?
                                                <div className="pull-right">
                                                    <Button className="btn-info" placeholder={this.state.resources.addEditNotes}
                                                        onClick={() => { this.setState({ showNotes: true, showNotesType: 'notes' }) }}>
                                                        <span className="fa fa-edit"/>
                                                    </Button>
                                                </div> : ''
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-control-header-label">{this.state.resources.hrSourcingSupport}</ControlLabel>
                                    </div>
                                </div>
                                <hr className="ap-hr-normal" />
                                {/* <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">Other HR recruiting support required?: <span className={"ap-control-sub-label " + (readOnly == true ? 'ap-hidden' : '')}> - (Only for corporate position)</span></ControlLabel>
                                        {
                                            readOnly == false ?
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <Button 
                                                            id="corporatePositionYes"
                                                            name="corporatePosition"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('corporatePosition', true)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            Yes
                                                        </Button>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <Button 
                                                            id="corporatePositionNo"
                                                            name="corporatePosition"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('corporatePosition', false)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            No
                                                        </Button>
                                                    </div>
                                                </div> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.getYesNoButtonValue('corporatePosition')}</ControlLabel></div>
                                        }                        
                                    </div>
                                </div> */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.doYouHaveAnInternalCandidateForPromotionIntoThisRole}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <Button 
                                                            id="internalCandidateYes"
                                                            name="internalCandidate"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('internalCandidate', true)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.yes}
                                                        </Button>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <Button 
                                                            id="internalCandidateNo"
                                                            name="internalCandidate"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('internalCandidate', false)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.no}
                                                        </Button>
                                                    </div>
                                                </div> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.getYesNoButtonValue('internalCandidate')}</ControlLabel></div>
                                        }
                                        
                                    </div>
                                </div>
                                <div className={"row " + (this.state.request.internalCandidate == true ? '' : 'ap-hidden')}>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.whatIsTheirName}</ControlLabel> 
                                        {
                                            readOnly == false ?
                                                <FormControl 
                                                    id="internalCandidateNames"
                                                    type="text" 
                                                    value={this.state.request.internalCandidateNames}
                                                    onChange={this.onFormControlChange}
                                                    maxLength="1000" 
                                                    readOnly={readOnly}>
                                                </FormControl> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.internalCandidateNames}</ControlLabel></div>
                                        }
                                    </div>
                                    <div className="col-md-6">
                                    <ControlLabel className="ap-report-control-label">{this.state.resources.currentJobTitle}</ControlLabel> 
                                        {
                                            readOnly == false ?
                                                <FormControl 
                                                    id="internalCandidateJobTitle"
                                                    type="text" 
                                                    value={this.state.request.internalCandidateJobTitle}
                                                    onChange={this.onFormControlChange}
                                                    maxLength="1000" 
                                                    readOnly={readOnly}>
                                                </FormControl> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.internalCandidateJobTitle}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className={"row " + (this.state.request.internalCandidate == true ? '' : 'ap-hidden')}>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.salary}:</ControlLabel> 
                                        {
                                            readOnly == false ?
                                                <FormControl 
                                                    id="internalCandidateSalary"
                                                    type="text" 
                                                    value={this.state.request.internalCandidateSalary}
                                                    onChange={this.onSalaryChange}
                                                    className={this.state.errors.filter(x => x.field == 'salaryMinimum').length > 0 ? 'ap-report-control-error' : ''}
                                                    disabled={readOnly} >
                                                </FormControl> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.internalCandidateSalary}</ControlLabel></div>
                                        }
                                    </div>
                                    <div className="col-md-6">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.currentJobType}:</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <Button 
                                                            id="internalCandidateJobTypeStaff"
                                                            name="internalCandidateJobType"
                                                            className={"btn-info ap-fullsize " + (this.state.request.internalCandidateJobType == "Staff" ? "btn-selected" : "")}
                                                            onClick={this.onCurrentJobTypeClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.staff}
                                                        </Button>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <Button 
                                                            id="internalCandidateJobTypeTemp"
                                                            name="internalCandidateJobType"
                                                            className={"btn-info ap-fullsize " + (this.state.request.internalCandidateJobType == "Temp" ? "btn-selected" : "")}
                                                            onClick={this.onCurrentJobTypeClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.temp}
                                                        </Button>
                                                    </div>
                                                </div> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.internalCandidateJobType}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className={"row " + (this.state.request.internalCandidate == true ? '' : 'ap-hidden')}>
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.additionalComments}:</ControlLabel>
                                        <FormControl 
                                            id="internalCandidateComments"
                                            componentClass="textarea"
                                            rows="5"
                                            value={this.state.request.internalCandidateComments}
                                            onChange={this.onFormControlChange}
                                            readOnly={readOnly}
                                            className={readOnly == true ? "ap-report-control-label ap-black-color ap-white-background" : "" }>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.isThisAConfidentialHire} {readOnly == true ? '' : <span className="ap-control-sub-label"> - ({this.state.resources.isThisAConfidentialHireMessage})</span>}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <Button 
                                                            id="confidentialYes"
                                                            name="confidential"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('confidential', true)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.yes}
                                                        </Button>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <Button 
                                                            id="confidentialNo"
                                                            name="confidential"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('confidential', false)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.no}
                                                        </Button>
                                                    </div>
                                                </div> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.getYesNoButtonValue('confidential')}</ControlLabel></div>
                                        }
                                        
                                    </div>
                                </div>
                                {/* <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">Please indicate below where you would like your job posted:</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <Checkbox 
                                                            id="postWebRecruiter"
                                                            onChange={this.onCheckBoxChange}
                                                            checked={this.state.request.postWebRecruiter}
                                                            disabled={readOnly}>
                                                            <ControlLabel className="ap-report-control-label" style={{ "paddingLeft" : "0px" }}>WebRecruiter</ControlLabel>
                                                        </Checkbox>
                                                    </div>
                                                    <div className="col-md-9">
                                                        <Checkbox 
                                                            id="postInterAct"
                                                            onChange={this.onCheckBoxChange}
                                                            checked={this.state.request.postInterAct}
                                                            disabled={readOnly}>
                                                            <ControlLabel className="ap-report-control-label" style={{ "paddingLeft" : "0px" }}>InterAct Career Internal Activities</ControlLabel>
                                                        </Checkbox>
                                                    </div>
                                                </div> :
                                                <div>
                                                    <ControlLabel className="ap-report-control-label ap-black-color">
                                                    {
                                                        (this.state.request.postWebRecruiter == true ? "WebRecruiter" : "") + 
                                                        (this.state.request.postWebRecruiter == true ? ", " : "") + 
                                                        (this.state.request.postInterAct == true ? "InterAct Career Internal Activities" : "")
                                                    } 
                                                    </ControlLabel>
                                                </div>
                                        }
                                        
                                    </div>
                                </div> */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.postOnInternetJobBoards}</ControlLabel>
                                        {
                                            readOnly == false ?
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <Button 
                                                            id="postOnInternetJobBoardsYes"
                                                            name="postOnInternetJobBoards"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('postOnInternetJobBoards', true)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.yes}
                                                        </Button>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <Button 
                                                            id="postOnInternetJobBoardsNo"
                                                            name="postOnInternetJobBoards"
                                                            className={"btn-info ap-fullsize " + this.getYesNoButtonClass('postOnInternetJobBoards', false)}
                                                            onClick={this.onYesNoClick}
                                                            disabled={readOnly}>
                                                            {this.state.resources.no}
                                                        </Button>
                                                    </div>
                                                </div> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.getYesNoButtonValue('postOnInternetJobBoards')}</ControlLabel></div>
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.emailResumesTo}:</ControlLabel> 
                                        {
                                            readOnly == false ?
                                                <FormControl 
                                                    id="emailRecipient"
                                                    type="text" 
                                                    value={this.state.request.emailRecipient}
                                                    onChange={this.onFormControlChange}
                                                    maxLength="200" 
                                                    readOnly={readOnly}>
                                                </FormControl> :
                                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.emailRecipient}</ControlLabel></div>
                                        }
                                        
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ControlLabel className="ap-report-control-label">{this.state.resources.otherHRSupportRequired}:</ControlLabel>
                                        <FormControl 
                                            id="hrSupportRequiredNotes"
                                            componentClass="textarea"
                                            rows="5"
                                            value={this.state.request.hrSupportRequiredNotes}
                                            onChange={this.onFormControlChange}
                                            readOnly={readOnly}
                                            className={readOnly == true ? "ap-report-control-label ap-black-color ap-white-background" : "" }>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                            <div className={"ap-white-background " + (this.role == 'supervisor' ? 'ap-hidden' : '')} style={{ "padding": "10px", "marginTop" : "10px" }}>
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div style={{ "textAlign" : "center" }}><ControlLabel className="ap-report-control-label ap-black-color">{this.state.resources.toBeCompletedByHROnly}</ControlLabel></div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <ControlLabel className="ap-report-control-label">{this.state.resources.eeocJobCode}:</ControlLabel>
                                            {
                                                readOnly == false ?
                                                    <FormControl 
                                                        id="eeocJobCode"
                                                        type="text" 
                                                        value={this.state.request.eeocJobCode}
                                                        onChange={this.onFormControlChange}
                                                        maxLength="50" 
                                                        readOnly={readOnly}>
                                                    </FormControl> :
                                                    <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.eeocJobCode}</ControlLabel></div>
                                            }
                                            
                                        </div>
                                        <div className="col-md-6">
                                            <ControlLabel className="ap-report-control-label">{this.state.resources.jobGrade}:</ControlLabel>
                                            {
                                                readOnly == false ?
                                                    <FormControl 
                                                        id="jobGrade"
                                                        type="text" 
                                                        value={this.state.request.jobGrade}
                                                        onChange={this.onFormControlChange}
                                                        maxLength="50" 
                                                        readOnly={readOnly}>
                                                    </FormControl> : 
                                                    <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.jobGrade}</ControlLabel></div>
                                            }
                                            
                                        </div>
                                    </div>
                                    {/* <div className="row">
                                        <div className="col-md-12">
                                            <ControlLabel className="ap-report-control-label">Position Type:</ControlLabel>
                                            {
                                                readOnly == false ?
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <Button 
                                                                id="positionTypeStaffing"
                                                                className={"btn-info ap-fullsize " + (this.state.request.positionType == "Staffing" ? "btn-selected" : "")}
                                                                onClick={this.onPositionTypeClick}
                                                                disabled={readOnly}>
                                                                Staffing
                                                            </Button>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <Button 
                                                                id="positionTypeNonStaffing"
                                                                className={"btn-info ap-fullsize " + (this.state.request.positionType == "Non-Staffing" ? "btn-selected" : "")}
                                                                onClick={this.onPositionTypeClick}
                                                                disabled={readOnly}>
                                                                Non-Staffing
                                                            </Button>
                                                        </div>
                                                    </div> :
                                                    <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.positionType}</ControlLabel></div>
                                            }
                                        </div>
                                    </div> */}
                                    <hr className="ap-hr-normal" style={{ "marginTop" : "10px" }} />
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div style={{ "textAlign" : "center" }}><ControlLabel className="ap-report-control-label ap-black-color">{this.state.resources.externalSalaryComparison}</ControlLabel></div>
                                        </div>
                                    </div>
                                    {externalSalaryComparison}
                                    <div className={"row " + (readOnly == true ? 'ap-hidden' : '')}>
                                        <div className="col-md-12">
                                            <span>
                                                <Button 
                                                    id="addSalarySurvey"
                                                    className="btn-info"
                                                    onClick={this.onAddSalarySurveyClick}
                                                    disabled={readOnly}>
                                                    <i className="glyphicon glyphicon-plus"></i>
                                                </Button>
                                            </span> 
                                            <span className="ap-5-margin-left">
                                                <ControlLabel>{this.state.resources.addAdditionalSalaryComparison}</ControlLabel>
                                            </span>
                                        </div>
                                    </div>
                                    <hr className="ap-hr-normal" style={{ "marginTop" : "10px" }}/>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <ControlLabel className="ap-report-control-label">{this.state.resources.flsaStatusQualified}:</ControlLabel>
                                            {
                                                readOnly == false ?
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <Button 
                                                                id="flsaQualifiedYes"
                                                                name="flsaQualified"
                                                                className={"btn-info ap-fullsize " + this.getYesNoButtonClass('flsaQualified', true)}
                                                                onClick={this.onYesNoClick}
                                                                disabled={readOnly}>
                                                                {this.state.resources.yes}
                                                            </Button>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <Button 
                                                                id="flsaQualifiedNo"
                                                                name="flsaQualified"
                                                                className={"btn-info ap-fullsize " + this.getYesNoButtonClass('flsaQualified', false)}
                                                                onClick={this.onYesNoClick}
                                                                disabled={readOnly}>
                                                                {this.state.resources.no}
                                                            </Button>
                                                        </div>
                                                    </div> :
                                                    <div><ControlLabel className="ap-report-control-label ap-black-color">{this.getYesNoButtonValue('flsaQaualified')}</ControlLabel></div>
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <ControlLabel className="ap-report-control-label">{this.state.resources.exemptUnderWhichFLSAExemptionCategory} <span className={"ap-control-sub-label " + (readOnly == true ? 'ap-hidden' : '')}> - ({this.state.resources.flsaExemptionCategory})</span></ControlLabel> 
                                            <FormControl 
                                                id="flsaExemptionNotes"
                                                componentClass="textarea"
                                                rows="5"
                                                value={this.state.request.flsaExemptionNotes}
                                                onChange={this.onFormControlChange}
                                                disabled={readOnly}
                                                className={readOnly == true ? "ap-report-control-label ap-black-color ap-white-background" : "" }>
                                            </FormControl>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <ControlLabel className="ap-report-control-label">{this.state.resources.averageInternalCompensationForComparablePositions}:</ControlLabel>
                                            {
                                                readOnly == false ?
                                                    <FormControl 
                                                        id="averageInternalCompensationNotes"
                                                        type="text"
                                                        value={this.state.request.averageInternalCompensationNotes}
                                                        onChange={this.onFormControlChange}
                                                        disabled={readOnly}>
                                                    </FormControl> :
                                                    <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.request.averageInternalCompensationNotes}</ControlLabel></div>
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <ControlLabel className="ap-report-control-label">{this.state.resources.salaryRange}: {readOnly == true ? '' : <span className="ap-control-sub-label"> - ({this.state.resources.salaryRangeSample})</span>}</ControlLabel>
                                            </div>
                                            {
                                                readOnly == false ?
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="salary-range">
                                                                <span className="salary-range minimum">
                                                                    <FormControl 
                                                                        id="salaryMinimum"
                                                                        type="text" 
                                                                        value={this.state.request.salaryMinimum}
                                                                        onChange={this.onSalaryChange}
                                                                        className={this.state.errors.filter(x => x.field == 'salaryMinimum').length > 0 ? 'ap-report-control-error' : ''}
                                                                        disabled={readOnly}
                                                                        maxLength="10">
                                                                    </FormControl>
                                                                </span>
                                                                <span className="salary-range arrow">
                                                                    <i className="glyphicon glyphicon-arrow-right"></i>
                                                                </span>
                                                                <span className="salary-range maximum">
                                                                    <FormControl 
                                                                        id="salaryMaximum"
                                                                        type="text" 
                                                                        value={this.state.request.salaryMaximum}
                                                                        onChange={this.onSalaryChange}
                                                                        className={this.state.errors.filter(x => x.field == 'salaryMaximum').length > 0 ? 'ap-report-control-error' : ''}
                                                                        disabled={readOnly}
                                                                        maxLength="10">
                                                                    </FormControl>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div> : 
                                                    <div>
                                                        <ControlLabel className="ap-report-control-label ap-black-color">
                                                        {
                                                            (this.state.request.salaryMinimum != null ? this.state.request.salaryMinimum : '') + 
                                                            ' - ' + 
                                                            (this.state.request.salaryMaximum != null ? this.state.request.salaryMaximum : '')
                                                        }
                                                        </ControlLabel>
                                                    </div>
                                            }
                                            
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <ControlLabel className="ap-report-control-label">{this.state.resources.notes}:</ControlLabel>
                                            <FormControl 
                                                id="hrNotes"
                                                componentClass="textarea"
                                                rows="5"
                                                value={this.state.request.hrNotes}
                                                onChange={this.onFormControlChange}
                                                readOnly={readOnly}
                                                className={readOnly == true ? "ap-report-control-label ap-black-color ap-white-background" : "" }>
                                            </FormControl>
                                            {
                                                readOnly == true ?
                                                    <div className="pull-right">
                                                        <Button className="btn-info" placeholder="Add/Edit Notes"
                                                            onClick={() => { this.setState({ showNotes: true, showNotesType: 'hrNotes' }) }}>
                                                            <span className="fa fa-edit"/>
                                                        </Button>
                                                    </div> : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ap-white-background">
                                <div style={{ "padding" : "10px" }}>
                                    <hr className="ap-hr-normal" style={{ "paddingTop" : "10px", "marginBottom" : "10px" }} />
                                    <div className={"row " + (buttonMessage.length == 0 ? 'ap-hidden' : '' )}>
                                        <div className="col-md-12">
                                            <ControlLabel className="ap-report-control-label"><i>{buttonMessage}</i></ControlLabel>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="ap-button-container">
                                                {this.getButtons()}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"row " + (this.state.errors.length > 0 ? "" : "ap-hidden")} style={{ "marginTop" : "10px" }}>
                                        <div className="col-md-12 col-lg-12">
                                            <Alert bsStyle="danger">
                                                <ul>
                                                    {errors}
                                                </ul>
                                            </Alert>
                                        </div>
                                    </div>
                                    <div className={"row " + (this.state.successMessage.length > 0 ? "" : "ap-hidden")} style={{ "marginTop" : "10px" }}>
                                        <div className="col-md-12 col-lg-12">
                                            <Alert bsStyle="success">
                                                <ControlLabel>{this.state.successMessage}</ControlLabel>
                                            </Alert>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <RequestActivityList data={this.state.request.activities} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}